// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/quote-tile/quote-tile.component.scss
// module id = 594
// module chunks = 0